import { render, staticRenderFns } from "./fi.vue?vue&type=template&id=4f8f013c&scoped=true&"
import script from "./fi.vue?vue&type=script&lang=js&"
export * from "./fi.vue?vue&type=script&lang=js&"
import style0 from "./fi.vue?vue&type=style&index=0&id=4f8f013c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f013c",
  null
  
)

export default component.exports